export const apis = {
  templateConfig: {
    getAll: "/vmrs/api/v1/template-configs",
    getByID: "/vmrs/api/v1/template-configs", // '/{id}'
  },

  provider: {
    url: "/vmrs/api/v1/providers",
    getAll: "/vmrs/api/v1/providers",
    getByID: "/vmrs/api/v1/providers", // '/{id}'
    getByAdmin: "/vmrs/api/v1/providers/by-admin",
  },

  searchImage: {
    search: "/vmrs/api/v1/search", // post
    getHistoryByUser: "/vmrs/api/v1/history-searching/by-user",
  },



  cart: {
    addImage: "/vmrs/api/v1/carts/items",
    delImage: "/vmrs/api/v1/carts/remove-image-to-cart",
    getImage: "/vmrs/api/v1/carts/me",
    getProductBunbleByItemType: "/vmrs/api/v1/metakeys/product-bundle",
  },

  order: {

    getPriority: "/vmrs/api/v1/metakeys?page=0&size=1000",
    userOrder: "/vmrs/api/v1/orders/by-user",
    userOrderCbd: "/api/v1/orders",
    changeStatus: "/vmrs/api/v1/orders/status",
    getArchiveOrderById: "/vmrs/api/v1/order-archiveds",
    adminOrder: "/vmrs/api/v1/orders/by-admin",
    getProductTypeId: "/vmrs/api/v1/metakeys/productype-id",
    getOrderByIdUser: "/vmrs/api/v1/orders",
    getOrderByIdAdmin: "/vmrs/api/v1/orders",
    getSegmentByIdOrder: "/vmrs/api/v1/order-taskings/oneatlas/attempts",
    getSchemaCosmos: "/vmrs/api/v1/orders/cosmos/tasking/opportunity-search",
    getProduction: "/vmrs/api/v1/metakeys/option-per-product-type",
    confirmOrderTaskingAdmin: "/vmrs/api/v1/order-taskings/oneatlas/order",
    getProductionSpectralProcessing:
      "/vmrs/api/v1/metakeys/option-per-product-type-v2",
    approveArchiveOrder: "/vmrs/api/v1/order-archiveds/body/status",
  },
  metaKey: {
    default: "/vmrs/api/v1/metakeys",
  },
  project: {
    url: "/vmrs/api/v1/projects",
    getMyProjects: "/vmrs/api/v1/projects",
  },
  globalConfig: {
    url: "/vmrs/api/v1/global-config",
  },
  orderTasking: {
    orderUser: "/vmrs/api/v1/orders/by-user",
    orderUserCbd: "/api/v1/orders",
    orderAdmin: "/vmrs/api/v1/orders/by-admin",
    updateStatus: "/vmrs/api/v1/order-taskings/oneatlas/order/status",
    getDetailOrderTaskingByUer: "/vmrs/api/v1/orders",
    getDetailOrderTaskingByAdmin: "/vmrs/api/v1/orders",
    getDownload: "/api/v1/downloads/order"
  },

  basemap: {
    url: "/vmrs/api/v1/basemaps",
  },

  organization: {
    url: "/vmrs/api/v1/organizations",
  },

  feedback: {
    getList: '/vmrs/api/v1/tickets',
    addList: '/api/v1/tickets',
  },
  history: {
    getListUpdate: '/api/v1/loggings',
    getListDownload: '/api/v1/history-downloads'
  },
  dashboard: {
    getData: '/api/v1/statistics'
  }
};
